
import { monicaBio, rossBio, joeyBio } from './rachelBios'
import { monicaReviewerReviewHinge, rossReviewerReviewBumble, joeyReviewerReviewTinder } from './rachelReviewerReviews'

export const monicaReviewerProfile = {
  _id: 'monicaReviewerProfileId',
  userId: 'monicaUserId',
  email: 'monica@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-monica-1-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...monicaBio },
  profileReviews: [
    // { ...monicaProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...monicaReviewerReviewHinge }
  ],
}

export const rossReviewerProfile = {
  _id: 'rossReviewerProfileId',
  userId: 'rossUserId',
  email: 'ross@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ross-1-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...rossBio },
  profileReviews: [
    // { ...rossProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...rossReviewerReviewBumble }
  ],
}

export const joeyReviewerProfile = {
  _id: 'joeyReviewerProfileId',
  userId: 'joeyUserId',
  email: 'joey@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-joey-1-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...joeyBio },
  profileReviews: [
    // { ...joeyProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...joeyReviewerReviewTinder }
  ],
}